/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sign: NonNullable<unknown> }} Prefix_Inputmoney1Inputs */

const en_prefix_inputmoney1 = /** @type {(inputs: Prefix_Inputmoney1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sign} `)
};

/**
* | output |
* | --- |
* | "{sign}" |
*
* @param {Prefix_Inputmoney1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const prefix_inputmoney1 = /** @type {((inputs: Prefix_Inputmoney1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prefix_Inputmoney1Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_prefix_inputmoney1(inputs)
});
export { prefix_inputmoney1 as "prefix_inputMoney" }